// src/components/TestimonialCard.js
// Updated: 12/01/2025 06:20 PM

import React from 'react';
import { Card, CardContent, Typography, Box, IconButton, Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import FavoriteIcon from '@mui/icons-material/Favorite';

function TestimonialCard({ testimonial, currentUser, userRole, onDelete, onReact }) {
  const canDelete = currentUser.uid === testimonial.authorId || userRole === 'Leadership' || userRole === 'Church Administrator';
  const creationDate = testimonial.createdAt?.toDate().toLocaleDateString();
  const hasReacted = testimonial.reactedByUids?.includes(currentUser.uid) || false;

  return (
    <Card sx={{ mb: 2, backgroundColor: testimonial.isPrivate ? '#fffde7' : 'white' }}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', mb: 2 }}>
              {testimonial.text}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Shared {testimonial.isAnonymous ? 'anonymously' : `by ${testimonial.authorName}`} on {creationDate}
            </Typography>
            {testimonial.isPrivate && (
              <Typography variant="caption" color="text.secondary" sx={{ fontStyle: 'italic', display: 'block' }}>
                (Private: Visible only to you and leadership)
              </Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', ml: 2 }}>
            <Button
              variant="outlined"
              startIcon={<FavoriteIcon />}
              onClick={() => onReact(testimonial.id)}
              size="small"
              disabled={hasReacted}
            >
              {hasReacted ? 'Amen' : 'Amen'}
            </Button>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {testimonial.reactionCount || 0} amens
            </Typography>
            {canDelete && (
              <IconButton onClick={() => onDelete(testimonial.id)} aria-label="delete" sx={{ mt: 1 }}>
                <DeleteIcon />
              </IconButton>
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}

export default TestimonialCard;